import { Injectable } from '@angular/core';
import { ToastMessageOptions } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  private readonly notificationSubject = new Subject<ToastMessageOptions>();
  readonly notificationSubject$ = this.notificationSubject.asObservable();

  private readonly notificationRemoveSubject = new Subject<string>();
  readonly notificationRemoveSubject$ =
    this.notificationRemoveSubject.asObservable();

  constructor(private translateService: TranslateService) {}

  addApiLoadingNotification(notificationId: string): void {
    this.notificationSubject.next({
      severity: 'info',
      summary: 'Loading',
      detail: 'Just wait a few seconds',
      life: 30000000,
      key: 'loadingApi',
    });
  }

  addProgressNotification(summary: string, detail: string): void {
    this.notificationRemoveSubject.next('progressApi');
    this.notificationSubject.next({
      severity: 'info',
      summary: summary,
      detail: detail,
      life: 30000000,
      key: 'progressApi',
      closable: false,
    });
  }

  removeProgressNotification(): void {
    this.notificationRemoveSubject.next('progressApi');
  }

  deleteApiLoadingNotification(notificationId: string): void {
    this.notificationRemoveSubject.next('loadingApi');
  }

  addApiErrorNotification(errorCode: string, life = 3000): void {
    this.notificationSubject.next({
      severity: 'error',
      summary: 'Error',
      detail: errorCode,
      life: life,
      key: 'nService',
    });
  }
  showSuccessNotification(
    message: string,
    title = 'global.notification.success.title',
  ): void {
    this.notificationSubject.next({
      severity: 'success',
      summary: this.translateService.instant(title),
      detail: this.translateService.instant(message),
      life: 3000,
      key: 'nService',
    });
  }
}
